// extracted by mini-css-extract-plugin
export default {"drawings":"drawings__TedVQ","empty":"empty__MZVnh","container":"container__cDLKF","chartList":"chartList__prkA8","sectionLabel":"sectionLabel__cFkNU"};